<template>
  <custom-dialog width="1100px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <custom-table type="checkbox" v-model="tableSelect" :data="tableList" tableCode="partybReceive" :filterArr="['isRented']"></custom-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" :disabled="!tableSelect.length" @click="confirm">{{ $t('crm_partyb_receive.que_ding_shou_huo') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableList: [],
      tableSelect: [],
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    // 收货设备列表
    getTableList: function () {
      this.$getJSON(apis.DeviceContractReceive, {
        bizId: this.model.data.bizId,
        bizClass: this.model.data.bizClass,
        operateType: 2,
      }).then((res) => {
        this.tableList = res.data;
      });
    },
    // 保存
    confirm: function () {
      const deviceList = this.tableSelect.map(t => ({
        bodyNum: t.bodyNum,
        deviceBizType: t.deviceBizType,
        deviceId: t.deviceId,
        productCode: t.productCode,
        modemSn: t.modemSn,
      }));
      this.$postJSON(apis.contractReceive, {
        bizId: this.model.data.bizId,
        bizClass: this.model.data.bizClass,
        deviceList: deviceList,
        operateType: 2,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.visible = false;
        this.Bus.$emit('contract_device');
        this.$emit('success');
      });
    },
  },
};
</script>
